import React from 'react';
import classnames from 'classnames';
import TransitionSlider from '~/components/views/common/TransitionSlider/TransitionSlider';
import FormattedMessageWrapper from '~/components/views/FormattedMessageWrapper/FormattedMessageWrapper';
import type ErrorRecord from '~/data/ErrorRecord';
import type { ErrorType } from '~/data/ErrorRecord';
import './ErrorText.pcss';

export interface Props {
  className?: string;
  error: ErrorRecord | ErrorType;
  values?: any;
  testId?: string;
}

const ErrorText: React.FC<Props> = ({ error, className, values, testId }) => (
  <TransitionSlider isVisible={true}>
    <div data-testid={testId} className={classnames('ErrorText', className)}>
      <FormattedMessageWrapper langKey={error.description} values={values} />
    </div>
  </TransitionSlider>
);

export default ErrorText;
